<template>
<div class="h-screen">
  <side-bar
    ref="rail"
    :sections="sections"
    @open="setSideOpen"
    @close="setSideClosed"
    noExitButton="true"
    origin="Groove.cm"
    logo="GdLogo"
    class="h-full"
  >
    <template slot="Home"> </template>
    <template slot="Marketplace">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li
            class="mb-2 block-data relative focus:outline-none"
            @click="openUrl('/groovesell/marketplace', '_self')"
          >
            {{ $t('frontend_sites_side_bar_groove_affiliate_market') }}
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_builder_events_and_workshop')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
            <li class="mb-2 block-data relative">
              <a href="https://marketerscruise.com/" target="_blank" rel="noopener noreferrer">Marketers’ Cruise</a>
            </li>
        </ul>
      </div>
    </template>

    <template slot="header">
      <div class="flex flex-col">
        <div>Groove.cm</div>
      </div>
    </template>
  </side-bar>
  <account-modal ref="accountModal" :open="editingUserDetails" @close="closeAccountModal" />
  <groove-help-modal :open="helpOpen" @close="helpOpen = false" />
</div>
</template>

<script>
import SideBar from './DashboardSideBar';
import HomeIcon from '@/assets/images/icons/Home.svg';
import MarketplaceIcon from '@/assets/images/icons/Marketplace.svg';
import EventsIcon from '@/assets/images/icons/Events.svg';
import APIIcon from '@/assets/images/icons/API.svg';
import HelpIcon from '@groovepages/gd-ui-kit/assets/support-icon.svg';
import { AccountModal } from '@/design-system/account-adapter';
import GrooveHelpModal from './GrooveHelpModal.vue';

export default {
  name: 'SidebarMenu',
  components: {
    SideBar,
    AccountModal,
    GrooveHelpModal
  },
  data() {
    return {
      editingUserDetails: false,
      helpOpen: false,
    };
  },
  computed: {
    sections() {
      const items = [
        { name: 'Home', icon: HomeIcon, doNotOpen: 1 },
        { name: 'Marketplace', icon: MarketplaceIcon },
        { name: this.$t('frontend_builder_events_and_workshop'), icon: EventsIcon },
        { name: 'Developers & SDK', icon: APIIcon, doNotOpen: 1 },
        { name: 'Groove Help', icon: HelpIcon, doNotOpen: 1 }
      ];

      return items
    }
  },

  methods: {
    setSideOpen(side) {
      if (side === 'Home') {
        this.sendToDashboard();
      } else if (side === 'Groove Help') {
        this.helpOpen = true;
        this.$refs.rail.close();
      } else if (side === 'Developers & SDK') {
        this.editingUserDetails = true;
        this.$refs.rail.close();
        this.$nextTick(() => {
          this.$refs.accountModal.$refs.tabsNew.openTab('Developer');
        });
      }
    },

    setSideClosed() {},

    sendToDashboard() {
      this.$router.push({ name: 'dashboard' });
    },

    sendToDashboardApp() {
      this.$router.push({ name: 'dashboardApp' });
    },

    sendToMore() {
      this.$router.push({ name: 'more' });
    },

    openUrl(url, target) {
      if (target === '_self' && url.startsWith('/groovesell')) {
        const separator = url.includes('?') ? '&' : '?';
        url = `${url}${separator}shell=${Date.now()}`;
      }
      window.open(url, target);
    },

    routeToGrooveMarketPlace() {
      window.location.replace('/static/groovemarketplace');
    },
    closeAccountModal() {
      this.editingUserDetails = false;
    },
  }
};
</script>
